<script>
import draggable from "vuedraggable";
import ExifReader from "exifreader";

const { PDFDocument, PDFName, PDFRawStream, EncryptedPDFError } = require("pdf-lib");

export default {
  name: "proofFilepicker",
  components: {
    draggable,
  },
  props: {
    existingFile: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mode: "files",
      dragDepth: 0,
      urlToUpload: "",
      isUploading: false,
      findex: this.existingFile.length,
      uploading: _.cloneDeep(this.existingFile),
      subState: null,
      supportedFileTypes: {
        video: [
          "video/x-quicktime",
          "video/quicktime",
          "video/xquicktime",
          "video/webm",
          "video/ogg",
          "video/mp4",
        ],
        audio: ["audio/wav", "audio/x-wav", "audio/xwav", "audio/mpeg", "audio/ogg", "audio/mp3"],
        image: [
          "image/jpeg",
          "image/tiff",
          "image/webp",
          "image/png",
          "image/bmp",
          "image/gif",
          "image/svg+xml",
        ],
        html: ["text/html"],
        text: [
          "text/css",
          "text/plain",
          "text/richtext",
          "text/yaml",
          "text/rtf",
          "text/csv",
        ],
        application: [
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/msword",
          "application/vnd.ms-word.document.macroEnabled.12",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/pdf",
        ],
        unknown: ["application/octet-stream"],
      },
      webpageProofType: "live",
      checkingWebpage: false,
    };
  },
  computed: {
    isLiveWebProofing: function () {
      return this.webpageProofType === "live";
    },
  },
  async mounted() {
    this.subState = await this.$A.BillingService.GetCurrentSubscriptionState();
  },
  methods: {
    GetIndex: function () {
      return ++this.findex;
    },
    fileKind: function (file) {
      if (file.web) return "web";
      if (file.image) return "image";
      if (file.video) return "video";
      if (file.audio) return "audio";
      return "document";
    },
    fileKindLabel: function (file) {
      return { web: "Website", image: "Image", video: "Video", audio: "Audio", document: "Document" }[this.fileKind(file)];
    },
    openFilePicker: function () {
      if (this.isUploading) return;
      this.$refs.fileInput.click();
    },
    onFileInputChange: function (event) {
      this.processFiles(event.target.files);
      event.target.value = "";
    },
    onDragEnter: function () {
      if (!this.isUploading) this.dragDepth++;
    },
    onDragLeave: function () {
      if (this.dragDepth > 0) this.dragDepth--;
    },
    onDrop: function (event) {
      this.dragDepth = 0;
      if (this.isUploading) return;
      this.processFiles(event.dataTransfer.files);
    },
    processFiles: function (fileList) {
      let self = this;
      let contains = this.contains;
      Array.from(fileList || []).forEach(function (f) {
        if (!self.canAddMoreFiles()) {
          return;
        }
        let type = f.type;
        if (type === "" && f.name.indexOf(".docx")) {
          type =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        }

        let rec = {
          uuid: self.GetIndex(),
          id: 0,
          file: f,
          name: f.name,
          mb: Math.ceil(f.size / 1000 / 1000),
          audio: contains(type, self.supportedFileTypes.audio),
          web: contains(type, self.supportedFileTypes.html),
          video: contains(type, self.supportedFileTypes.video),
          image: contains(type, self.supportedFileTypes.image),
          document:
            contains(type, self.supportedFileTypes.application) ||
            contains(type, self.supportedFileTypes.unknown) ||
            contains(type, self.supportedFileTypes.text),
          unsupported: false,
          uploadProgress: 0,
          error: "",
          skip: false,
        };
        if ((rec.audio || rec.video) && self.$A.Auth.account.subscriptionState.sku === "free") {
          rec.error = "Upgrade To Access Audio And Video Proofing";
          rec.skip = true;
        }
        if (rec.mb > 2000) {
          rec.error = "File Size Limit is 2gb";
          rec.skip = true;
        }
        if (
          !rec.audio &&
          !rec.web &&
          !rec.video &&
          !rec.image &&
          !rec.document
        ) {
          rec.error = "'" + type + "' is not supported";
          rec.unsupported = true;
          rec.skip = true;
        }

        if (rec.image && type !== "image/svg+xml" && type !== "image/gif") {
          self.checkIfImageHasCMYKColor(rec);
        } else if (rec.document && type === "application/pdf") {
          self.checkPdfForProblems(rec);
        } else {
          self.uploading.push(rec);
          self.$emit("fileAdded", rec);
        }
      });
    },
    UploadFiles: async function (proofId, proofVersionId) {
      let self = this;
      this.isUploading = true;
      if (proofId === 0 || proofVersionId === 0) {
        throw new Error("Proof Ids Not Set");
      }
      for (let i = 0; i < this.uploading.length; i++) {
        let file = this.uploading[i];
        if ((file.id !== undefined && file.id > 0) || file.skip) {
        } else {
          let completeFunc = function () {
            self.$scrollTo(
              document.getElementById("upload_file_" + file.uuid),
              1000,
              { offset: -60 }
            );
          };
          if (file.urlSource) {
            await this.$A.ProofFileService.UploadFileFromUrl(
              proofId,
              proofVersionId,
              file,
              completeFunc
            );
          } else if (file.web === 1) {
            await this.$A.ProofFileService.UploadUrl(
              proofId,
              proofVersionId,
              file,
              completeFunc,
              file.isLiveWebProofing
            );
          } else {
            await this.$A.ProofFileService.UploadFile(
              proofId,
              proofVersionId,
              file,
              completeFunc
            );
          }
          if (file.noFilesLeft !== undefined) {
            return this.uploading;
          }
        }
      }
      this.isUploading = false;
      return this.uploading;
    },
    DeleteFile: function (file) {
      if (this.isUploading || file.id > 0) return;
      this.uploading.splice(this.uploading.indexOf(file), 1);
    },
    GetFileStatus: function () {
      return this.uploading;
    },
    GetFileIDsOrdered: function () {
      return this.uploading.map((f) => f.id);
    },
    reset: function () {
      this.uploading = [];
    },
    AddUrl: async function ($event) {
      $event.preventDefault();
      if (!this.canAddMoreFiles()) {
        return;
      }
      if (
        this.urlToUpload.length === 0 ||
        !this.$A.IsWebUrl(this.urlToUpload)
      ) {
        this.$A.AlertUser("Please Enter A Valid URL");
        return;
      }
      let urlObject = null;
      try {
        if (!this.urlToUpload.startsWith("http")) {
          this.urlToUpload = "https://" + this.urlToUpload;
        }
        urlObject = new URL(this.urlToUpload);
      } catch (e) {
        this.$A.AlertUser("Unable to validate given URL. Please, check your URL and try again.");
        return;
      }
      if (this.urlToUpload.indexOf("docs.google.com") !== -1) {
        this.$A.AlertUser("Ashore does not currently support Google Docs. Please upload your proof as a Word document.");
        return;
      }
      let scriptDetected = undefined;
      let url = urlObject.href;
      let protocol = urlObject.protocol;
      if (this.isLiveWebProofing) {
        let scriptStatus = await this.checkLiveWebProofingUrl(urlObject);
        if (!scriptStatus) {
          return;
        }
        scriptDetected = scriptStatus.scriptFound;
        url = scriptStatus.url;
      }
      this.urlToUpload = "";
      let self = this;
      let urlRec = {
        uuid: this.GetIndex(),
        id: 0,
        file: { name: url },
        name: url,
        mb: 0,
        web: 1,
        video: 0,
        document: 0,
        image: 0,
        uploadProgress: 0,
        error: "",
        skip: false,
        isLiveWebProofing: self.isLiveWebProofing,
        scriptDetected: scriptDetected,
        protocol: protocol,
        checking: false,
      };
      this.uploading.push(urlRec);
      this.$emit("fileAdded", urlRec);
    },
    checkLiveWebProofingUrl: async function (urlObject) {
      this.checkingWebpage = true;
      let url = urlObject.href;
      let scriptStatus = await this.checkScriptOnWebsite(url);
      if (!scriptStatus.scriptFound && urlObject.protocol === "http:") {
        urlObject.protocol = "https:";
        scriptStatus = await this.checkScriptOnWebsite(urlObject.href);
        if (!scriptStatus.loaded) {
          this.$A.AlertUser("Unable to validate URL. Please check the URL and try again.");
          this.checkingWebpage = false;
          return null;
        }
        if (scriptStatus.scriptFound) {
          url = urlObject.href;
        }
      }
      this.checkingWebpage = false;
      return {
        url: url,
        scriptFound: scriptStatus.scriptFound,
      };
    },
    contains: function (type, array) {
      let has = false;
      array.forEach(function (i) {
        if (type.toLowerCase() === i) {
          has = true;
        }
      });
      return has;
    },
    withFileReader: function (file, callback) {
      let fileReader = new FileReader();
      fileReader.onload = callback;
      fileReader.readAsArrayBuffer(file);
    },
    checkIfImageHasCMYKColor: async function (rec) {
      let self = this;
      this.withFileReader(rec.file, (e) => {
        try {
          let tags = ExifReader.load(e.target.result);
          if (tags.ColorMode && tags.ColorMode.value && tags.ColorMode.value === "4") { // CMYK
            self.$A.AlertUser(
              "CMYK file uploaded. Please note that CMYK files may not render correctly in browsers.",
              "warning",
              6000
            );
          }
          self.uploading.push(rec);
          self.$emit("fileAdded", rec);
        } catch (err) {
          console.log("error", err);
          self.uploading.push(rec);
          self.$emit("fileAdded", rec);
        }
      });
    },
    checkPdfForProblems: function (rec) {
      let self = this;
      this.withFileReader(rec.file, async (e) => {
        let hasCMYKColor = false;
        try {
          const pdfDoc = await PDFDocument.load(e.target.result);

          pdfDoc.getPages().forEach((page) => {
            const { Contents, XObject } = page.node.normalizedEntries();

            let refs = [];
            XObject.entries().forEach(([, ref]) => refs.push(ref));
            Contents.asArray().forEach((ref) => refs.push(ref));

            hasCMYKColor = self.checkIfPdfHasCMYKColor(page, refs);
          });
          if (hasCMYKColor) {
            self.$A.AlertUser(
              "CMYK file uploaded. Please note that CMYK files may not render correctly in browsers.",
              "warning",
              6000
            );
          }
          self.uploading.push(rec);
          self.$emit("fileAdded", rec);
        } catch (err) {
          let errorMessage = `${err}`;
          const encryptedErrorMessage = "Error: Input document to `PDFDocument.load` is encrypted";
          if (err instanceof EncryptedPDFError || errorMessage.startsWith(encryptedErrorMessage)) {
            $A.AlertUser(
              "Pdf is encrypted and can't be processed.",
              "warning",
              100000
            );
            return;
          }
          self.uploading.push(rec);
          self.$emit("fileAdded", rec);
        }
      });
    },
    checkIfPdfHasCMYKColor: function (page, refs) {
      return refs.some((ref) => {
        const pdfObject = page.doc.context.lookup(ref);
        if (!(pdfObject instanceof PDFRawStream)) return;
        const colorSpace = pdfObject.dict.lookup(PDFName.of("ColorSpace"));
        if (colorSpace && colorSpace.encodedName)
          return (colorSpace && colorSpace.encodedName && colorSpace.encodedName === "/DeviceCMYK");
      });
    },
    canAddMoreFiles: function () {
      let curTotal =
        _.get(this.subState, "remainingFilesOnPlanThisCycle", 0) - this.uploading.length;
      let newTotal = curTotal - this.uploading.length;
      if (newTotal < 0) {
        this.$A.AlertUser(
          "You Have Run Out Files To Send. Upgrade Now To Add More",
          "warning",
          100000
        );
        return false;
      }
      return true;
    },
    checkScriptOnWebsite: function (url) {
      return this.$A.LiveProofService.checkUrl(url);
    },
    checkScriptOnWebsiteAgain: function (event, file) {
      event.preventDefault();
      file.uploadProgress = 1;
      file.uploadProgress = 25;
      file.checking = true;
      this.checkScriptOnWebsite(file.name).then((status) => {
        file.scriptDetected = status.scriptFound;
        file.uploadProgress = 100;
        setTimeout(() => {
          file.checking = false;
          file.uploadProgress = 0;
        }, 100);
      });
      file.uploadProgress = 100;
    },
  },
};
</script>

<template>
  <div class="picker">

    <!-- Mode switch -->
    <div class="picker-mode" role="tablist">
      <button
        type="button"
        role="tab"
        class="mode-btn"
        :class="{ 'is-active': mode === 'files' }"
        :aria-selected="mode === 'files' ? 'true' : 'false'"
        @click="mode = 'files'"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
        Upload files
      </button>
      <button
        type="button"
        role="tab"
        class="mode-btn"
        :class="{ 'is-active': mode === 'web' }"
        :aria-selected="mode === 'web' ? 'true' : 'false'"
        @click="mode = 'web'"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
        Capture a website
      </button>
    </div>

    <!-- FILES MODE -->
    <div v-show="mode === 'files'" class="mode-panel">
      <div
        class="dropzone"
        :class="{ 'is-dragging': dragDepth > 0, 'is-disabled': isUploading }"
        @click="openFilePicker"
        @dragenter.prevent="onDragEnter"
        @dragover.prevent
        @dragleave="onDragLeave"
        @drop.prevent="onDrop"
      >
        <input
          ref="fileInput"
          type="file"
          multiple
          class="dz-input"
          :disabled="isUploading"
          @change="onFileInputChange"
          data-cy="uploadFilesInput"
        />
        <div class="dz-art" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
        </div>
        <p class="dz-headline">
          <span class="dz-strong">Drop files here</span> or <span class="dz-browse">browse</span>
        </p>
        <p class="dz-note">
          PDFs, images, Word documents and HTML. Business plans add MP4 video and MP3 / WAV audio. Up to 2&nbsp;GB per file.
        </p>
      </div>
    </div>

    <!-- WEB MODE -->
    <div v-show="mode === 'web'" class="mode-panel">
      <div class="web-choice" role="radiogroup">
        <label class="web-card" :class="{ 'is-selected': webpageProofType === 'live' }">
          <input
            type="radio"
            id="webpage-live-option"
            value="live"
            v-model="webpageProofType"
          />
          <span class="web-card-radio" aria-hidden="true"></span>
          <span class="web-card-body">
            <span class="web-card-title">Live webpage</span>
            <span class="web-card-sub">Interactive review of your live site — approvers can browse, comment and switch resolutions.</span>
          </span>
        </label>
        <label class="web-card" :class="{ 'is-selected': webpageProofType === 'static' }">
          <input
            type="radio"
            id="webpage-static-option"
            value="static"
            v-model="webpageProofType"
          />
          <span class="web-card-radio" aria-hidden="true"></span>
          <span class="web-card-body">
            <span class="web-card-title">Webpage screenshot</span>
            <span class="web-card-sub">A static capture at 1200, 992, 768 and 576 pixels wide.</span>
          </span>
        </label>
      </div>

      <form class="web-url-row" @submit="AddUrl($event)">
        <input
          type="text"
          class="web-url-input"
          placeholder="https://example.com"
          v-model="urlToUpload"
        />
        <button type="submit" class="web-add-btn" :disabled="checkingWebpage">
          <b-spinner v-show="checkingWebpage" type="grow" small></b-spinner>
          {{ checkingWebpage ? "Checking…" : "Add website" }}
        </button>
      </form>
    </div>

    <!-- QUEUE -->
    <div v-if="uploading.length" class="queue" data-cy="uploadFilesContainer">
      <div class="queue-head">
        <span class="queue-count">{{ uploading.length }} {{ uploading.length === 1 ? "file" : "files" }} ready</span>
        <span v-if="uploading.length > 1" class="queue-hint">Drag to set the review order</span>
      </div>
      <draggable
        v-model="uploading"
        handle=".q-handle"
        :sort="true"
        ghost-class="q-ghost"
        class="queue-list"
      >
        <div
          v-for="file in uploading"
          :id="'upload_file_' + file.uuid"
          :key="'upload_file_' + file.uuid"
          class="q-row"
          :class="{ 'has-error': !!file.error, 'needs-script': file.isLiveWebProofing && file.web > 0 && file.scriptDetected !== undefined && !file.scriptDetected }"
        >
          <div class="q-line">
            <span class="q-handle" :class="{ 'is-locked': isUploading }" title="Drag to reorder">
              <svg width="10" height="14" viewBox="0 0 10 16" fill="currentColor" aria-hidden="true">
                <circle cx="2.5" cy="2.5" r="1.4" /><circle cx="7.5" cy="2.5" r="1.4" />
                <circle cx="2.5" cy="8" r="1.4" /><circle cx="7.5" cy="8" r="1.4" />
                <circle cx="2.5" cy="13.5" r="1.4" /><circle cx="7.5" cy="13.5" r="1.4" />
              </svg>
            </span>

            <span class="q-chip" :class="'q-chip-' + fileKind(file)" aria-hidden="true">
              <svg v-if="fileKind(file) === 'image'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <svg v-else-if="fileKind(file) === 'video'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="23 7 16 12 23 17 23 7" />
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
              </svg>
              <svg v-else-if="fileKind(file) === 'audio'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 18V5l12-2v13" />
                <circle cx="6" cy="18" r="3" />
                <circle cx="18" cy="16" r="3" />
              </svg>
              <svg v-else-if="fileKind(file) === 'web'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
              </svg>
              <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </span>

            <div class="q-main">
              <span class="q-name" :title="file.name">{{ file.name }}</span>
              <span class="q-meta">
                <span>{{ fileKindLabel(file) }}</span>
                <template v-if="!file.web && file.mb > 0">
                  <span class="q-meta-dot" aria-hidden="true">·</span>
                  <span>{{ file.mb }} MB</span>
                </template>
                <template v-if="file.error">
                  <span class="q-meta-dot" aria-hidden="true">·</span>
                  <span class="q-error-text">{{ file.error }}</span>
                </template>
              </span>
            </div>

            <span
              v-if="file.web > 0 && file.scriptDetected !== undefined"
              class="q-script-badge"
              :class="file.scriptDetected ? 'is-found' : 'is-missing'"
            >
              <span class="q-script-dot" aria-hidden="true"></span>
              {{ file.scriptDetected ? "Script detected" : "Script not detected" }}
            </span>

            <button
              type="button"
              class="q-remove"
              :disabled="isUploading || file.id > 0"
              @click="DeleteFile(file)"
              aria-label="Remove file"
              title="Remove"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <!-- Live web proofing: embed script callout -->
          <div
            v-if="file.isLiveWebProofing && file.web > 0 && file.scriptDetected !== undefined && !file.scriptDetected"
            class="q-script-help"
          >
            <p class="q-script-help-text">
              Copy and paste this tracking code into every page of your site, just before the <code>&lt;/body&gt;</code> tag.
            </p>
            <pre class="q-script-code"><code>&lt;!-- Ashore Embed Code --&gt;
&lt;script src="{{ $A.LiveProofService.scriptUrl }}"&gt;&lt;/script&gt;</code></pre>
            <button type="button" class="q-script-check" @click="(e) => checkScriptOnWebsiteAgain(e, file)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="23 4 23 10 17 10" />
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
              </svg>
              Check again
            </button>
          </div>

          <b-progress
            v-show="isUploading || file.isLiveWebProofing"
            :value="file.uploadProgress"
            class="q-progress"
          ></b-progress>
        </div>
      </draggable>
    </div>
  </div>
</template>

<style scoped>
.picker {
  padding: 20px 24px 24px;
}

/* ============== MODE SWITCH ============== */
.picker-mode {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background: #eef0f3;
  border-radius: 999px;
  margin-bottom: 16px;
}

.mode-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 7px 14px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 140ms ease, color 140ms ease, box-shadow 140ms ease;
}
.mode-btn:hover { color: #374151; }
.mode-btn.is-active {
  background: #fff;
  color: #017a48;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.10), 0 1px 1px rgba(8, 11, 13, 0.06);
}

/* ============== DROPZONE ============== */
.dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px 32px;
  border: 1.5px dashed #c9cfd8;
  border-radius: 12px;
  background: #fbfcfd;
  cursor: pointer;
  transition: border-color 160ms ease, background-color 160ms ease;
}
.dropzone:hover {
  border-color: #019256;
  background: rgba(1, 146, 86, 0.03);
}
.dropzone.is-dragging {
  border-color: #019256;
  border-style: solid;
  background:
    repeating-linear-gradient(
      -45deg,
      rgba(1, 146, 86, 0.05),
      rgba(1, 146, 86, 0.05) 10px,
      rgba(1, 146, 86, 0.09) 10px,
      rgba(1, 146, 86, 0.09) 20px
    );
}
.dropzone.is-disabled {
  opacity: 0.55;
  pointer-events: none;
}

.dz-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.dz-art {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 999px;
  background: rgba(1, 146, 86, 0.10);
  color: #019256;
  margin-bottom: 14px;
  transition: transform 200ms cubic-bezier(0.22, 1, 0.36, 1);
}
.dropzone:hover .dz-art {
  transform: translateY(-2px);
}
.dropzone.is-dragging .dz-art {
  animation: dz-bob 900ms ease-in-out infinite;
  background: #019256;
  color: #fff;
}
@keyframes dz-bob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

.dz-headline {
  margin: 0 0 6px;
  font-size: 15px;
  color: #4b5563;
}
.dz-strong {
  font-weight: 600;
  color: #1f2937;
}
.dz-browse {
  color: #019256;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.dz-note {
  margin: 0;
  max-width: 420px;
  font-size: 12px;
  line-height: 1.5;
  color: #6b7280;
}

/* ============== WEB CAPTURE ============== */
.web-choice {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
}

.web-card {
  position: relative;
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  padding: 14px 16px;
  border: 1px solid rgba(15, 23, 42, 0.10);
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}
.web-card:hover { border-color: rgba(1, 146, 86, 0.45); }
.web-card.is-selected {
  border-color: #019256;
  background: rgba(1, 146, 86, 0.035);
  box-shadow: 0 0 0 1px #019256 inset;
}

.web-card input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.web-card-radio {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 2px;
  border-radius: 999px;
  border: 1.5px solid #c9cfd8;
  background: #fff;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}
.web-card.is-selected .web-card-radio {
  border-color: #019256;
  box-shadow: inset 0 0 0 4px #019256;
}

.web-card-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.web-card-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #1f2937;
}
.web-card-sub {
  font-size: 12px;
  line-height: 1.5;
  color: #575759;
}

.web-url-row {
  display: flex;
  gap: 10px;
}

.web-url-input {
  flex: 1;
  min-width: 0;
  padding: 9px 13px;
  height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  font-size: 14px;
  color: #1f2937;
  outline: none;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.web-url-input:focus {
  border-color: #019256;
  box-shadow: 0 0 0 3px rgba(1, 146, 86, 0.12);
}

.web-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  height: 40px;
  padding: 0 18px;
  border: 0;
  border-radius: 8px;
  background: #019256;
  color: #fff;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(1, 146, 86, 0.2);
  transition: background-color 140ms ease;
}
.web-add-btn:hover:not(:disabled) { background: #017a48; }
.web-add-btn:disabled { opacity: 0.65; cursor: default; }

@media (max-width: 700px) {
  .picker {
    padding: 16px;
  }
  .picker-mode {
    display: flex;
    width: 100%;
  }
  .mode-btn {
    flex: 1;
    min-width: 0;
    padding: 8px 10px;
    font-size: 12.5px;
  }
  .dropzone {
    padding: 28px 16px 24px;
  }
  .web-choice { flex-direction: column; }
  .web-url-row { flex-direction: column; }
  .web-add-btn { width: 100%; }
  .q-script-help { padding-left: 16px; }
}

/* ============== QUEUE ============== */
.queue {
  margin-top: 20px;
}

.queue-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.queue-count {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
}
.queue-hint {
  font-size: 12px;
  color: #6b7280;
}

.queue-list {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.q-row {
  position: relative;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  animation: q-enter 260ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
.q-row:last-child { border-bottom: 0; }
.q-row.has-error {
  background: rgba(235, 70, 84, 0.04);
  box-shadow: inset 3px 0 0 #eb4654;
}
.q-row.needs-script {
  background: rgba(245, 158, 11, 0.04);
  box-shadow: inset 3px 0 0 #f59e0b;
}

@keyframes q-enter {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.q-ghost {
  opacity: 0.35;
}

.q-line {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px 11px 8px;
}

.q-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 32px;
  flex-shrink: 0;
  color: #c1c7d0;
  cursor: grab;
  border-radius: 6px;
  transition: color 120ms ease, background-color 120ms ease;
}
.q-handle:hover {
  color: #6b7280;
  background: rgba(15, 23, 42, 0.05);
}
.q-handle:active { cursor: grabbing; }
.q-handle.is-locked {
  pointer-events: none;
  opacity: 0.4;
}

.q-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
}
.q-chip-image { background: rgba(1, 146, 86, 0.10); color: #017a48; }
.q-chip-video { background: rgba(79, 70, 229, 0.10); color: #4f46e5; }
.q-chip-audio { background: rgba(217, 119, 6, 0.12); color: #b45309; }
.q-chip-web { background: rgba(13, 148, 136, 0.10); color: #0d9488; }
.q-chip-document { background: rgba(71, 85, 105, 0.10); color: #475569; }

.q-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.q-name {
  font-size: 13.5px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.q-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
  min-width: 0;
}
.q-meta-dot { color: #d3d8de; }
.q-error-text {
  color: #c92b39;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.q-script-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
}
.q-script-badge.is-found {
  background: rgba(1, 146, 86, 0.10);
  color: #017a48;
}
.q-script-badge.is-missing {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
}
.q-script-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}

.q-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}
.q-remove:hover:not(:disabled) {
  background: rgba(235, 70, 84, 0.10);
  color: #c92b39;
}
.q-remove:disabled {
  opacity: 0.35;
  cursor: default;
}

/* ============== SCRIPT HELP ============== */
.q-script-help {
  padding: 0 14px 14px 56px;
}
.q-script-help-text {
  margin: 0 0 8px;
  font-size: 12.5px;
  line-height: 1.5;
  color: #6b7280;
}
.q-script-help-text code {
  font-size: 12px;
  color: #374151;
  background: rgba(15, 23, 42, 0.06);
  padding: 1px 5px;
  border-radius: 4px;
}

.q-script-code {
  margin: 0 0 10px;
  padding: 12px 14px;
  background: #1d2430;
  color: #d6e2d9;
  font-size: 12px;
  line-height: 1.6;
  border-radius: 8px;
  overflow-x: auto;
  white-space: pre;
}

.q-script-check {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  background: #fff;
  font-size: 12.5px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  transition: background-color 120ms ease, border-color 120ms ease;
}
.q-script-check:hover {
  border-color: rgba(1, 146, 86, 0.5);
  color: #017a48;
}

/* ============== PROGRESS ============== */
.q-progress {
  height: 3px;
  border-radius: 0;
  background-color: rgba(15, 23, 42, 0.05);
  margin: 0;
}
.q-progress ::v-deep .progress-bar {
  background-color: #019256;
}
</style>
